import { render } from "./AsahiLanguageSelector.vue?vue&type=template&id=243be2cd&scoped=true&ts=true"
import script from "./AsahiLanguageSelector.vue?vue&type=script&lang=ts"
export * from "./AsahiLanguageSelector.vue?vue&type=script&lang=ts"

import "./AsahiLanguageSelector.vue?vue&type=style&index=0&id=243be2cd&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243be2cd"]])

export default __exports__